/**
 * The portal a rule is saved from. The server builds the alert's `link` with it, so a rule set up on
 * portal.fireiq.de links back to portal.fireiq.de and not to The Real Insight. The server accepts only the
 * known portal addresses and ignores anything else (a preview or a local dev server), so sending it is safe.
 *
 * tri-model's class does not carry this field, so it is attached after construction, like the cooldown.
 */
export const withPortalRootURL = <T extends object>(rule: T, origin: string = window.location.origin): T & { portalRootURL: string } =>
    Object.assign(rule, { portalRootURL: origin });
